export const BREAKPOINT_DATERANGEPICKER_TWO_ROWS = 590;
